// The morning digests (DIGEST-01..03): read here, and emailed to owners, admins and managers once the platform turns
// digest email on (DIGEST-04, DIGEST-05, D-042).
import { useState } from "react";
import { deliveryLine, fmtDay } from "../lib/format";
import { useMember } from "../app/session";
import { Card, Empty, ErrorNote, Loading, Page, useLoad, useToast } from "../app/ui";

export function Digests() {
  const { api, tz } = useMember();
  const { data, error, loading } = useLoad(() => api.digests(), [api]);
  const [open, setOpen] = useState(0);
  const toast = useToast();

  if (loading && !data) return <Loading />;
  if (!data) return <ErrorNote error={error} />;
  const digest = data[open];
  const delivery = digest ? deliveryLine(digest, tz) : null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(digest.text);
      toast("Copied. Paste it into WhatsApp or email.");
    } catch {
      toast("Could not copy; select the text instead.", true);
    }
  };

  return (
    <Page
      title="Morning digest"
      sub="Built every morning at your digest time (see Settings)."
    >
      {data.length === 0 && (
        <Card>
          <Empty>The first digest arrives tomorrow morning.</Empty>
        </Card>
      )}
      {digest && (
        <div className="split">
          <Card
            title={fmtDay(digest.day)}
            actions={
              <button
                className="small"
                onClick={() => void copy()}
              >
                Copy text
              </button>
            }
          >
            {delivery && <p className="faint" style={{ marginTop: 0 }}>{delivery}</p>}
            <pre className="digest">{digest.text}</pre>
          </Card>
          <Card title="Earlier">
            <div className="list">
              {data.map((d, i) => (
                <button
                  key={d.id}
                  className={`ghost${i === open ? " primary" : ""}`}
                  style={{ justifyContent: "space-between" }}
                  onClick={() => setOpen(i)}
                >
                  {fmtDay(d.day)}{" "}
                  <span className="faint">
                    {d.status === "sent" ? "Sent" : ""}
                  </span>
                </button>
              ))}
            </div>
          </Card>
        </div>
      )}
    </Page>
  );
}
